import { Controller } from '@hotwired/stimulus';

// FilterPillsController — toggles aria-selected on click + dispatches a
// custom event (default name 'filter-pills:change') so host controllers
// can react. Host listens via:
//   data-action="filter-pills:change@window->host#handleFilter"
export default class extends Controller {
  static targets = ['pill'];
  static values = {
    eventName: { type: String, default: 'filter-pills:change' },
    active: String,
  };

  select(event) {
    const value = event.currentTarget.dataset.value;
    this.activeValue = value;

    this.pillTargets.forEach((pill) => {
      const isActive = pill.dataset.value === value;
      pill.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    // prefix: '' makes the event name literal (otherwise Stimulus prefixes
    // with 'filter-pills:'). We want the host to listen for exactly the
    // configured name.
    this.dispatch(this.eventNameValue, {
      detail: { value },
      bubbles: true,
      prefix: '',
    });
  }
}
